module.exports = __webpack_public_path__ + "static/fabric-calendar-weeknumber-275030360ad3ddd65f9fe2c0c35bc076.png";